import { combineReducers } from 'redux'
import browser from './browser'
import downloadExpose from './downloadExpose'
import downloadPdf from './downloadPdf'
import estate from './estate'
import estateFilterChoices from './estateFilterChoices'
import estateOverview from './estateOverview'
import estateOverviewFilters from './estateOverviewFilters'
import estateOverviewFiltersReady from './estateOverviewFiltersReady'
import estatePage from './estatePage'
import gform from './gform'
import google from './google'
import locationSuggestions from './locationSuggestions'
import loginModal from './loginModal'
import magazin from './magazin'
import newsletterRegistration from './newsletterRegistration'
import router from './router'
import searchAgent from './searchAgent'
import shortlist from './shortlist'
import subsidiariesSuggestions from './subsidiariesSuggestions'
import tippgeber from './tippgeber'
import unlockEstateAddress from './unlockEstateAddress'
import wertermittler from './wertermittler'

const appReducer = combineReducers({
  browser,
  downloadExpose,
  downloadPdf,
  estate,
  estateFilterChoices,
  estateOverview,
  estateOverviewFilters,
  estateOverviewFiltersReady,
  estatePage,
  gform,
  google,
  location: router,
  locationSuggestions,
  loginModal,
  magazin,
  newsletterRegistration,
  searchAgent,
  shortlist,
  subsidiariesSuggestions,
  tippgeber,
  unlockEstateAddress,
  wertermittler,
})

export default appReducer
